// @ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../../const/ApiEndPoints';

export default function useDocumentTemplate() {
  const getDocumentTemplates = () => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DOC.UPLOAD_TEMPLATE}`,
        { loader: false }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const uploadDocumentTemplate = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DOC.UPLOAD_TEMPLATE}`,
        body,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteDocumentTemplate = (body) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DOC.UPLOAD_TEMPLATE}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const createDocument = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DOC.DOCUMENT_TEMPLATE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const fetchSharableLink = (body) =>
    axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DOC.DOCUMENT_ONEDRIVE_URL}`,
        { params: body }
      )
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );

  const downloadTemplateDocument = (body, config = {}) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DOC.DOWNLOAD_TEMPLATE_DOCUMENT}`,
        {
          params: body,
          responseType: 'arraybuffer',
          ...config,
        }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };

  return {
    getDocumentTemplates,
    uploadDocumentTemplate,
    deleteDocumentTemplate,
    createDocument,
    fetchSharableLink,
    downloadTemplateDocument,
  };
}
